export default __webpack_public_path__ + "static/media/starFavoris.09e1e4f2.jpg";